import React from "react";
import { Col, Container, Modal, Row, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import ForgetPasswordHook from "../../hook/auth/ForgetPasswordHook";
import ReactInputVerificationCode from "react-input-verification-code";
import cookies from "js-cookie";
import { useTranslation } from "react-i18next";

const ForgetPassowrdPage = () => {
  const { t } = useTranslation();
  const currentLanguageCode = cookies.get("i18next") || "en";
  const isRTL = currentLanguageCode === "ar";

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const primaryColor = settingsRes?.data?.cartColor || settingsRes?.data?.primaryColor || "#3182ce";

  const [
    value,
    onChangeValue,
    sendCode,
    show,
    handleCloseModel,
    codeVerify,
    setCodeVerify,
    clearValue,
    handlePressed
  ] = ForgetPasswordHook();

  return (
    <div className="cart-page-bg font" style={{ minHeight: "100vh", display: "flex", alignItems: "center" }}>

      {/* OTP Verification Modal */}
      <Modal show={show} onHide={handleCloseModel} centered>
        <div className="border-0 shadow-sm font">
          <Modal.Header className="bg-light border-bottom-0 pb-0">
            <Modal.Title className="fw-bold fs-5 text-dark font">
              <i className="fa-solid fa-envelope-circle-check me-2 text-success"></i>
              {t("code sent to email")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-4 text-center">
            <p className="text-muted fw-bold mb-4">{t("enter code")}</p>
            <div style={{ width: 'auto' }} className={`d-inline-block ${isRTL ? "otp-input-rtl" : ""}`}>
              <ReactInputVerificationCode
                placeholder=""
                onChange={setCodeVerify}
                value={codeVerify}
              />
            </div>
          </Modal.Body>
          <Modal.Footer className="border-top-0 pt-0 justify-content-center gap-2">
            <Button
              onClick={clearValue}
              className="px-4 py-2 fw-bold font"
              variant="light"
            >
              {t("delete")}
            </Button>
            <Button
              onClick={handlePressed}
              className="px-5 py-2 fw-bold text-white border-0 font"
              style={{ backgroundColor: primaryColor, borderRadius: '8px' }}
              disabled={codeVerify.length !== 4}
            >
              {t("verify")}
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Container>
        <Row className="justify-content-center">
          <Col lg="5" md="7" sm="10" xs="12">
            <div className="checkout-section-card" style={{ padding: "40px 32px" }}>

              {/* Header */}
              <div className="text-center mb-4">
                <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: `${primaryColor}15` }}>
                  <i className="fa-solid fa-key" style={{ fontSize: '1.5rem', color: primaryColor }}></i>
                </div>
                <h4 className="fw-bold text-dark mb-1">{t("forgot password")}</h4>
                <p className="text-muted small mb-0">{t("email or phone")}</p>
              </div>

              {/* Form */}
              <div className="mb-4">
                <label className="form-label text-muted fw-bold small">{t("email or phone")}</label>
                <div className="position-relative">
                  <i className="fa-solid fa-envelope position-absolute text-muted" style={{ top: '50%', right: '14px', transform: 'translateY(-50%)', fontSize: '0.85rem' }}></i>
                  <input
                    placeholder={t("email or phone")}
                    type="text"
                    name="email"
                    value={value}
                    onChange={onChangeValue}
                    className="form-control bg-light border-0 py-3 font"
                    style={{ paddingRight: '40px' }}
                  />
                </div>
              </div>

              {/* Submit */}
              <button
                onClick={sendCode}
                className="btn w-100 text-white fw-bold py-3 border-0 font"
                style={{ backgroundColor: primaryColor, borderRadius: '10px', fontSize: '1.05rem' }}
              >
                <i className="fa-solid fa-paper-plane me-2"></i>
                {t("send code")}
              </button>

            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgetPassowrdPage;
